module.exports = __webpack_public_path__ + "static/media/shadow.c1da5cf2.png";